import React from "react";
import { TextField, Grid} from "@mui/material";

export default function VirmentForm(props) {

    return(
        <Grid container columnSpacing={2} rowSpacing={2} >
            <Grid item sm={5}>
                <TextField
                fullWidth
                required={typeof props.isdepense ==='boolean' ? false : true}
                type="date"
                label={"Date"}
                InputLabelProps={{shrink: true}}
                inputProps={{max: new Date(props.don_date).toISOString().split("T")[0]}}
                value={props.repartition.date}
                onChange={(e)=>props.setRepartition(old => {old.date = e.target.value; return {...old}})}/>
            </Grid>
            <Grid item sm={8}>
                <TextField
                fullWidth
                required={typeof props.isdepense ==='boolean' ? false : true}
                label={props.pay_mode==='cb' ? "N° ticket marchand" :  "Référence"}
                // maxleng?
                value={props.repartition.ref}
                onChange={(e)=> props.setRepartition(old => ({...old, ref: e.target.value}))}/>
            </Grid>
            <Grid item sm={4}>
                <TextField
                fullWidth
                required
                label="montant"
                InputLabelProps={{shrink: true}}
                inputProps={{step:"0.01", min:'0'}}
                type="number"
                value={props.repartition.montant}
                onFocus={()=>{if(props.repartition.montant===0) props.setRepartition(old => ({...old, montant: ''}))}}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setReptotal(old => old-props.repartition.montant+Number(e.target.value))
                    props.setRepartition(previous => ({...previous, montant: Number(e.target.value)}))
                }else if(e.target.value===''){
                    props.setReptotal(old => old-props.repartition.montant)
                    props.setRepartition(previous => ({...previous, montant: ''}))
                }}}/>
            </Grid>
        </Grid>
    )
}